import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Message, MenuItem } from 'primeng/primeng';
import { HomeService } from '../home/home.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { Release } from '../home/release';
import { MainService } from '../main.service';
import { NewReleaseService } from '../new-release/new-release.service';
import { environment } from '../../environments/environment';
import { SelectQAComponent } from '../shared/select-qa/select-qa.component';

import { MatDialog } from '@angular/material';

import { ConfirmationService } from 'primeng/primeng';

const DownloadURL = environment.downloadURL;

@Component({
  selector: 'app-release-details',
  templateUrl: './release-details.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../../style.scss',
    './release-details.component.css']
})

export class ReleaseDetailsComponent implements OnInit {

  releaseData: Release[];

  searchPeriod = (365 * 24 * 60 * 60 * 1000) * 3
  options: {};
  fromDate: Date = new Date(new Date().getTime() - this.searchPeriod);
  toDate: Date = new Date();
  formatFromDate;
  formatToDate;
  fdMonth;
  toMonth;
  releaseID;
  activeIndex: number;
  workFlowList: any;
  projectList: any;
  isClient: boolean;

  msgs: Message[];
  items: MenuItem[];

  // workflows to display in 'change state' button
  workflows = ['Dev', 'QA', 'UAT', 'Prod'];

  userName = localStorage.getItem('userName');
  userEmail = localStorage.getItem('userEmail');
  isTour = localStorage.getItem('isTour');
  is_Admin = localStorage.getItem('is_Admin');

  _rid: any;
  _workflow: any;
  isMessage: boolean;
  sendCmt: string;
  changeWorkFlowOptions: { release_id: any; workflow: any; comment: any; user: string; };
  status: string;
  projectOptions: {};
  discardOptions: {};
  updateQAOptions: {};
  editEmailOptions: {};
  downloadOptions: { locaction: any; };
  activityResponce: any;
  responce: any;
  workflowMessage: string;
  showDetails: boolean = false;
  isDisplay: String;
  previousURL: String = localStorage.getItem('previousURL');

  constructor(
    private homeService: HomeService,
    private mainService: MainService,
    private newReleaseService: NewReleaseService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router) {
    const id: string = route.snapshot.params.id;
    this.releaseID = id;

  }


  // checkClient() {
  //   this.isClient = this.userEmail.includes("@");
  // }

  goToHome() {
    if (this.previousURL != undefined) {
      this.router.navigate([this.previousURL]);
    } else {
      this.router.navigate(['/Home']);
    }

  }

  getProjects() {
    var that = this;
    this.projectOptions = {
      user: this.userEmail
    };
    this.mainService.getProjectList(this.projectOptions).then(projects => {
      that.projectList = projects;
    });



  }

  confirmReject(r: Release) {
    if (r.owner == this.userName || r.uploaded_by == this.userName || r.qa == this.userName || this.is_Admin == '1') {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to reject this release?',
        header: 'Reject Confirmation',
        accept: () => {
          this.rejectRelease(r);
        },
        reject: () => {
          this.msgs = [];
          this.msgs = [{ severity: 'info', summary: 'Request cancelled' }];
        }
      });
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Reject Release', detail: 'No Permission' });
    }
  }

  // reject release
  rejectRelease(r: Release) {
    this.discardOptions = {
      id: r.id
    };

    this.homeService.rejectRelease(this.discardOptions).then(reject => {
      this.responce = reject.status;
      this.msgs = [];
      this.msgs = [{ severity: 'success', summary: 'Release Rejected' }];

      setTimeout(() => {
        this.getReleaseData();
      },
        500);


    });
  }

  getReleaseData() {

    this.fdMonth = (this.fromDate.getMonth() + 1);
    this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();

    this.toMonth = (this.toDate.getMonth() + 1);
    this.formatToDate = this.toDate.getDate() + '/' + this.toMonth + '/' + this.toDate.getFullYear();

    this.options = {
      fd: this.formatFromDate,
      td: this.formatToDate,
      p: '',
      c: '',
      pList: '',
      cList: '',
      workflow: '',
      release_id: this.releaseID
    };


    this.releaseData = [];
    this.homeService.getReleaseData(this.options).then(release => {

      if (release.length != undefined) {
        this.releaseData = release;

        if (this.projectList == undefined) {
          this.getProjects();
        }

        setTimeout(() => {
          for (var i = 0; i < this.projectList.length; i++) {
            if (this.projectList[i].key === this.releaseData[0].pkey) {
              this.showDetails = true;
            }
            else if (this.is_Admin == '1') {
              this.showDetails = true;
            }
          }
          if (this.showDetails === false) {
            this.isDisplay = "You Don't Have Permission to view this Bundle...";
          }
        },
          500);

      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });
  }

  getWorkflow() {
    this.mainService.getWorkflow(this.options).then(workflow => {
      this.workFlowList = workflow;

      this.items = [];
      for (var i = 0; i < this.workFlowList.length; i++) {

        if (i != 0) {
          var obj = { label: this.workFlowList[i].workflow };
          this.items.push(obj);

        }
      }
    });
  }

  addComment() {
    if (this.workflowMessage == undefined) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Empty Comment' });
    } else if (this.workflowMessage.length < 20) {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Comment Too Short' });
    } else {
      var userCmt = this.workflowMessage;

      this.sendCmt = (userCmt.replace("<p>", "")).replace("</p>", "");

      this.sendWorkflowUpdate();

      this.workflowMessage = '';
      this.isMessage = false;
    }

  }

  changeWorkFlow(rd: Release) {
    this._rid = rd.id;
    this._workflow = rd.workflow_id;

    if (rd.workflow_id == 0 && (rd.qa == undefined || rd.owner == this.userName)) {
      var editStage: any[] = this.releaseData.filter(temp =>
        temp.workflow_id == rd.workflow_id)
      editStage[0].workflow_id += 1;
      this._workflow = editStage[0].workflow_id + 1;

      setTimeout(() => {
        if (rd.qa != undefined && (rd.qa == this.userName || rd.owner == this.userName || this.is_Admin == '1')) {
          this.sendWorkflowUpdate();
        } else {
          const dialogRef = this.dialog.open(SelectQAComponent, {
            width: '900px',
            data: rd,
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result == undefined) {
              this.getReleaseData();
            } else {
              this.updateQA(result.data, result.qa);

            }

          });
        }
      },
        100);

    } else if (rd.qa == this.userName || rd.owner == this.userName || this.is_Admin == '1') {
      this.isMessage = true;
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Change Work Flow', detail: 'No Permission' });

    }
  }

  updateQA(data, qaData) {

    this.updateQAOptions = {
      release_id: data.id,
      qa: qaData.name
    };

    this.homeService.updateQA(this.updateQAOptions).then(workflow => {
      this.status = JSON.stringify(workflow.status);
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'QA Assigned' });
      setTimeout(() => {
        this.sendWorkflowUpdate();
        setTimeout(() => {
          this.getReleaseData();
        },
          500);
      },
        500);


    });

    this.editEmailOptions = {
      fromEmail: this.userEmail,
      fromUser: this.userName,
      toEmail: qaData.email,
      toUser: qaData.name,
      subject: "Moved to QA - " + data.version,
      version: data.version,
      project: data.project,
      cc: data.cc_list ? data.cc_list : '',
      // cc: this.selectedEditReleaseOwner.email,
      component: data.component,
      desc: data.description,
      index: data.id
    };

    this.sendEditEmail();


  }

  sendEditEmail() {
    this.newReleaseService.sendReleaseEmail(this.editEmailOptions).then(res => {
      this.activityResponce = res;
    });
  }

  sendWorkflowUpdate() {

    if (this.isMessage == true) {
      var editStage: any[] = this.releaseData.filter(temp =>
        temp.workflow_id == this._workflow)
      if (this._workflow < 4) {
        editStage[0].workflow_id += 1;
        this._workflow = editStage[0].workflow_id + 1;
      }
      this.sendCmt = "Moved to " + editStage[0].workflow;
    }

    this.changeWorkFlowOptions = {
      release_id: this._rid,
      workflow: this._workflow,
      comment: this.sendCmt,
      user: this.userEmail
    }

    this.mainService.sendEditWorkFlow(this.changeWorkFlowOptions).then(workflow => {
      this.status = JSON.stringify(workflow.status);
      this.msgs = [];
      this.msgs.push({ severity: 'success', summary: 'Stage Updated' });

      setTimeout(() => {
        this.getReleaseData();
      },
        0.5);

    });

  }

  // download release 
  sendLocation(s: Release) {

    this.downloadOptions = {
      locaction: s.storage_location
    };

    this.options = {
      user: this.userEmail,
      action: "Download Release",
      file: s.file_name
    };

    this.homeService.sendActivity(this.options).then(res => {
      this.activityResponce = res;
    });

    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;
    });

  }

  // download release note
  sendNoteLocation(s: Release) {
    this.downloadOptions = {
      locaction: s.release_note_location
    };

    this.options = {
      user: this.userEmail,
      action: "Download Release Note",
      file: s.release_note
    };

    this.homeService.sendActivity(this.options).then(res => {
      this.activityResponce = res;
    });

    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;
    });

  }

  // download Test Case
  sendTestCasesLocation(s: Release) {
    this.downloadOptions = {
      locaction: s.test_case_location
    };

    this.options = {
      user: this.userEmail,
      action: "Download Test Case",
      file: s.test_cases
    };

    this.homeService.sendActivity(this.options).then(res => {
      this.activityResponce = res;
    });

    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;
    });

  }

  getDownload() {

    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Downloading.....' });
    setTimeout(() => {
      window.location.href = DownloadURL;
    },
      1000);

  }

  ngOnInit() {
    this.getProjects();
    // this.checkClient();
    this.getReleaseData();
    // setTimeout(() => {
    //   this.getReleaseData();
    // },
    //   200);

    this.getWorkflow();
  }

}
